import React, { PropsWithChildren } from 'react';

import { Droppable } from 'react-beautiful-dnd';

import InnerList from './Components/InnerList/InnerList';
import { IListItem } from '../Utils/IListItem';
import ListFilters from '../Components/ListFilters';
import { IListProps } from '../Utils/IListProps';
import { useSelectedFilter } from '../Hooks/useSelectedFilter.hook';

type TDraggableList = <T extends IListItem>(
  props: PropsWithChildren<IListProps<T>> & { droppableId: string }
) => JSX.Element;

const DraggableList: TDraggableList = props => {
  const {
    buttonSetClassName,
    buttonSetStyle,
    className,
    context,
    customFilter,
    customSort,
    filters,
    initialFilter,
    itemHeight,
    items,
    listHeight,
    onSelect,
    renderItem,
    sorting,
    staffContext,
    title,
    droppableId
  } = props;

  const [selected, setSelected] = useSelectedFilter({ initialFilter });

  return (
    <Droppable droppableId={droppableId}>
      {(provided: any) => (
        <div ref={provided.innerRef}>
          <div className={`list ${className}`}>
            {title && <h3>{title}</h3>}

            <ListFilters
              buttonSetClassName={buttonSetClassName}
              buttonSetStyle={buttonSetStyle}
              filters={filters as any}
              onSelect={onSelect}
              selected={selected}
              setSelected={setSelected}
              staffContext={staffContext}
            />

            <InnerList
              customSort={customSort}
              sorting={sorting}
              itemHeight={itemHeight}
              renderItem={renderItem}
              context={context}
              listHeight={listHeight}
              items={items}
              customFilter={customFilter}
              filters={filters}
              selected={selected}
            />
          </div>

          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default DraggableList;
